export default function buildQualityConfig (legend, xAxis, data, baseValue, unit) {
  return {
    tooltip: {
      trigger: 'axis',
      show: true
    },
    grid: {
      left: '5%',
      right: '5%',
      top: '20%',
      bottom: '5%',
      width: 'auto',
      height: 'auto',
      containLabel: true
    },
    color: ['#FAAA00', '#4DCBCB', '#F3667C', '#1990FF', '#6300BF', '#7B4D12', '#F2919E', '#828116'],
    legend: {
      data: legend,
      top: '10',
      tooltip: {
        show: true
      }
    },
    title: {
      text: '单位:' + unit,
      left: '120',
      top: '10',
      textStyle: {
        fontSize: 14,
        fontStyle: 'normal',
        color: 'gray'
      }
    },
    toolbox: {
      show: true,
      top: '10',
      right: '16',
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        dataView: {show: false},
        restore: {},
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: xAxis
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value}'
      },
      max: function (value) {
        return Math.ceil(value.max < baseValue ? baseValue : value.max);
      },
      min: function (value) {
        return Math.floor(value.min > baseValue ? baseValue : value.min);
      }
    },
    series: data
  }
}



// WEBPACK FOOTER //
// ./src/config/chart/config_quality_line.js